import { createApp } from 'vue'
import App from './preview.vue'
import router from '../router'
import store from '../store'
import ElementPlus from 'element-plus'
import 'element-plus/lib/theme-chalk/index.css'
import { getIconfont } from '@/api/base'
import '@/styles/index.scss'

// 引入 tailwindcss
import 'tailwindcss/tailwind.css'

getIconfont().then(res => {
  const path = res.data.result
  const script = document.createElement('script')
  script.src = path
  document.querySelector('head').appendChild(script)
})

const app = createApp(App)
app.use(store).use(router).use(ElementPlus).mount('#app')
